import { toast } from 'react-toastify';
import querystring from 'querystring';
import _ from "lodash";

const MIME_TYPES = {
  "mny": "application/x-msmoney", 
  "vsmdi": "application/xml", 
  "nws": "message/rfc822", 
  "csproj": "text/plain", 
  "gz": "application/x-gzip", 
  "sldm": "application/vnd.ms-powerpoint.slide.macroEnabled.12", 
  "mp4": "video/mp4", 
  "mp2": "video/mpeg", 
  "mp3": "audio/mpeg", 
  "mno": "text/xml", 
  "sct": "text/scriptlet", 
  "scr": "text/plain", 
  "ac3": "audio/ac3", 
  "wmx": "video/x-ms-wmx", 
  "xtp": "application/octet-stream", 
  "wmp": "video/x-ms-wmp", 
  "tr": "application/x-troff", 
  "ts": "video/vnd.dlna.mpeg-tts", 
  "itlp": "application/x-itunes-itlp", 
  "wma": "audio/x-ms-wma", 
  "aspx": "application/xml", 
  "wmf": "application/x-msmetafile", 
  "wmd": "application/x-ms-wmd", 
  "mpf": "application/vnd.ms-mediapackage", 
  "mpg": "video/mpeg", 
  "mpe": "video/mpeg", 
  "mpa": "video/mpeg", 
  "wave": "audio/wav", 
  "ADTS": "audio/aac", 
  "mpp": "application/vnd.ms-project", 
  "wsc": "text/scriptlet", 
  "trm": "application/x-msterminal", 
  "dif": "video/x-dv", 
  "cmd": "text/plain", 
  "dib": "image/bmp", 
  "thmx": "application/vnd.ms-officetheme", 
  "evy": "application/envoy", 
  "cmx": "image/x-cmx", 
  "pbm": "image/x-portable-bitmap", 
  "dir": "application/x-director", 
  "vssettings": "text/xml", 
  "jfif": "image/pjpeg", 
  "pmw": "application/x-perfmon", 
  "htc": "text/x-component", 
  "hta": "application/hta", 
  "odp": "application/vnd.oasis.opendocument.presentation", 
  "cfg": "text/plain", 
  "htm": "text/html", 
  "ods": "application/vnd.oasis.opendocument.spreadsheet", 
  "odt": "application/vnd.oasis.opendocument.text", 
  "odh": "text/plain", 
  "odi": "application/vnd.oasis.opendocument.image", 
  "htt": "text/webviewhtml", 
  "odl": "text/plain", 
  "odm": "application/vnd.oasis.opendocument.text-master", 
  "pmc": "application/x-perfmon", 
  "pml": "application/x-perfmon", 
  "oda": "application/oda", 
  "odb": "application/vnd.oasis.opendocument.database", 
  "cat": "application/vnd.ms-pki.seccat", 
  "odf": "application/vnd.oasis.opendocument.formula", 
  "odg": "application/vnd.oasis.opendocument.graphics", 
  "mpeg": "video/mpeg", 
  "rtx": "text/richtext", 
  "wlpginstall": "application/x-wlpg-detect", 
  "u32": "application/octet-stream", 
  "m2ts": "video/vnd.dlna.mpeg-tts", 
  "mhtml": "message/rfc822", 
  "hdml": "text/x-hdml", 
  "wmz": "application/x-ms-wmz", 
  "xspf": "application/xspf+xml", 
  "tex": "application/x-tex", 
  "wdb": "application/vnd.ms-works", 
  "onepkg": "application/onenote", 
  "pict": "image/pict", 
  "m3u": "audio/x-mpegurl", 
  "vbs": "text/vbscript", 
  "skin": "application/xml", 
  "vbk": "video/mpeg", 
  "ipa": "application/x-itunes-ipa", 
  "ipg": "application/x-itunes-ipg", 
  "pntg": "image/x-macpaint", 
  "wmv": "video/x-ms-wmv", 
  "apk": "application/vnd.android.package-archive", 
  "xmta": "application/xml", 
  "wiq": "application/xml", 
  "txt": "text/plain", 
  "wbmp": "image/vnd.wap.wbmp", 
  "wiz": "application/msword", 
  "calx": "application/vnd.ms-office.calx", 
  "zip": "application/zip", 
  "chm": "application/octet-stream", 
  "mso": "application/octet-stream", 
  "msi": "application/octet-stream", 
  "msg": "application/vnd.ms-outlook", 
  "vspscc": "text/plain", 
  "3g2": "video/3gpp2", 
  "xaml": "application/xaml+xml", 
  "wml": "text/vnd.wap.wml", 
  "pfm": "application/octet-stream", 
  "aca": "application/octet-stream", 
  "flac": "audio/flac", 
  "xss": "application/xml", 
  "pfx": "application/x-pkcs12", 
  "iii": "application/x-iphone", 
  "me": "application/x-troff-me", 
  "searchConnector-ms": "application/windows-search-connector+xml", 
  "uls": "text/iuls", 
  "der": "application/x-x509-ca-cert", 
  "flr": "x-world/x-vrml", 
  "mk": "text/plain", 
  "flv": "video/x-flv", 
  "ms": "application/x-troff-ms", 
  "xht": "application/xhtml+xml", 
  "fla": "application/octet-stream", 
  "cab": "application/octet-stream", 
  "caf": "audio/x-caf", 
  "def": "text/plain", 
  "spx": "audio/ogg", 
  "hhp": "application/octet-stream", 
  "tar": "application/x-tar", 
  "dxr": "application/x-director", 
  "hhc": "application/x-oleobject", 
  "vstemplate": "text/xml", 
  "scd": "application/x-msschedule", 
  "WLMP": "application/wlmoviemaker", 
  "hhk": "application/octet-stream", 
  "dxf": "application/x-dxf", 
  "spc": "application/x-pkcs7-certificates", 
  "afm": "application/octet-stream", 
  "dwp": "application/octet-stream", 
  "csh": "application/x-csh", 
  "sit": "application/x-stuffit", 
  "asmx": "application/xml", 
  "snippet": "application/xml", 
  "dwf": "drawing/x-dwf", 
  "dwg": "application/acad", 
  "xhtml": "application/xhtml+xml", 
  "csv": "text/csv", 
  "config": "application/xml", 
  "css": "text/css", 
  "testsettings": "application/xml", 
  "map": "text/plain", 
  "snd": "audio/basic", 
  "vddproj": "text/plain", 
  "mac": "image/x-macpaint", 
  "snp": "application/octet-stream", 
  "divx": "video/divx", 
  "mak": "text/plain", 
  "man": "application/x-troff-man", 
  "vcproj": "application/xml", 
  "sh": "application/x-sh", 
  "jsxbin": "text/plain", 
  "lsf": "video/x-la-asf", 
  "vml": "text/xml", 
  "tts": "video/vnd.dlna.mpeg-tts", 
  "ite": "application/x-itunes-ite", 
  "jpeg": "image/jpeg", 
  "vsscc": "text/plain", 
  "lst": "text/plain", 
  "filters": "application/xml", 
  "csdproj": "text/plain", 
  "ttf": "application/font-sfnt", 
  "lsx": "video/x-la-asf", 
  "pcz": "application/octet-stream", 
  "pcx": "application/octet-stream", 
  "group": "text/x-ms-group", 
  "wrl": "x-world/x-vrml", 
  "pct": "image/pict", 
  "wri": "application/x-mswrite", 
  "fif": "application/fractals", 
  "vtt": "text/vtt", 
  "sldx": "application/vnd.openxmlformats-officedocument.presentationml.slide", 
  "tsv": "text/tab-separated-values", 
  "vtx": "application/vnd.visio", 
  "clp": "application/x-msclip", 
  "pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation", 
  "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document", 
  "vssscc": "text/plain", 
  "mk3d": "video/x-matroska-3d", 
  "qht": "text/x-html-insertion", 
  "mxp": "application/x-mmxp", 
  "dat": "application/octet-stream", 
  "lzh": "application/octet-stream", 
  "p12": "application/x-pkcs12", 
  "cer": "application/x-x509-ca-cert", 
  "docm": "application/vnd.ms-word.document.macroEnabled.12", 
  "qt": "video/quicktime", 
  "hqx": "application/mac-binhex40", 
  "xlm": "application/vnd.ms-excel", 
  "xll": "application/vnd.ms-excel", 
  "xlk": "application/vnd.ms-excel", 
  "qhtm": "text/x-html-insertion", 
  "xld": "application/vnd.ms-excel", 
  "xlc": "application/vnd.ms-excel", 
  "xla": "application/vnd.ms-excel", 
  "orderedtest": "application/xml", 
  "h": "text/plain", 
  "xlw": "application/vnd.ms-excel", 
  "xlt": "application/vnd.ms-excel", 
  "xls": "application/vnd.ms-excel", 
  "vsixlangpack": "text/xml", 
  "mdb": "application/x-msaccess", 
  "mda": "application/msaccess", 
  "vsix": "application/vsix", 
  "mde": "application/msaccess", 
  "gtar": "application/x-gtar", 
  "ras": "image/x-cmu-raster", 
  "mdp": "application/octet-stream", 
  "accft": "application/msaccess.ftemplate", 
  "tgz": "application/x-compressed", 
  "smz": "audio/x-smd", 
  "vcf": "text/x-vcard", 
  "smx": "audio/x-smd", 
  "m2t": "video/vnd.dlna.mpeg-tts", 
  "dsw": "text/plain", 
  "m2v": "video/mpeg", 
  "cdda": "audio/aiff", 
  "dsp": "application/octet-stream", 
  "rf": "image/vnd.rn-realflash", 
  "vcs": "text/plain", 
  "ra": "audio/x-pn-realaudio", 
  "smi": "application/octet-stream", 
  "rc": "text/plain", 
  "rm": "application/vnd.rn-realmedia", 
  "smd": "audio/x-smd", 
  "reg": "text/plain", 
  "asr": "video/x-ms-asf", 
  "asx": "video/x-ms-asf", 
  "pub": "application/x-mspublisher", 
  "asa": "application/xml", 
  "asf": "video/x-ms-asf", 
  "asd": "application/octet-stream", 
  "asi": "application/octet-stream", 
  "mmf": "application/x-smaf", 
  "asm": "text/plain", 
  "xpm": "image/x-xpixmap", 
  "midi": "audio/mid", 
  "ipproj": "text/plain", 
  "trx": "application/xml", 
  "isp": "application/x-internet-signup", 
  "mvb": "application/x-msmediaview", 
  "mvc": "application/x-miva-compiled", 
  "gif": "image/gif", 
  "pgm": "image/x-portable-graymap", 
  "one": "application/onenote", 
  "wasm": "application/wasm", 
  "pcast": "application/x-podcast", 
  "adobebridge": "application/x-bridge-url", 
  "mkv": "video/x-matroska", 
  "potm": "application/vnd.ms-powerpoint.template.macroEnabled.12", 
  "master": "application/xml", 
  "gpx": "application/gpx+xml", 
  "vsto": "application/x-ms-vsto", 
  "loadtest": "application/xml", 
  "pnz": "image/png", 
  "ogx": "application/ogg", 
  "ogv": "video/ogg", 
  "pnt": "image/x-macpaint", 
  "onetoc2": "application/onenote", 
  "pnm": "image/x-portable-anymap", 
  "toc": "application/octet-stream", 
  "ogg": "audio/ogg", 
  "oga": "audio/ogg", 
  "png": "image/png", 
  "onetmp": "application/onenote", 
  "aaf": "application/octet-stream", 
  "stl": "application/vnd.ms-pki.stl", 
  "dtd": "text/xml", 
  "stp": "application/step", 
  "aax": "audio/vnd.audible.aax", 
  "pma": "application/x-perfmon", 
  "prf": "application/pics-rules", 
  "AAC": "audio/aac", 
  "prm": "application/octet-stream", 
  "ram": "audio/x-pn-realaudio", 
  "mpv2": "video/mpeg", 
  "rat": "application/rat-file", 
  "rar": "application/x-rar-compressed", 
  "cpp": "text/plain", 
  "xrm-ms": "text/xml", 
  "anx": "application/annodex", 
  "7z": "application/x-7z-compressed", 
  "ascx": "application/xml", 
  "shtml": "text/html", 
  "odc": "application/vnd.oasis.opendocument.chart", 
  "osdx": "application/opensearchdescription+xml", 
  "mid": "audio/mid", 
  "lit": "application/x-ms-reader", 
  "323": "text/h323", 
  "wcm": "application/vnd.ms-works", 
  "XOML": "text/plain", 
  "ipsw": "application/x-itunes-ipsw", 
  "deploy": "application/octet-stream", 
  "safariextz": "application/x-safari-safariextz", 
  "jsx": "text/jscript", 
  "class": "application/x-java-applet", 
  "latex": "application/x-latex", 
  "exe": "application/octet-stream", 
  "axv": "video/annodex", 
  "doc": "application/msword", 
  "wmlsc": "application/vnd.wap.wmlscriptc", 
  "axa": "audio/annodex", 
  "lpk": "application/octet-stream", 
  "dot": "application/msword", 
  "cdf": "application/x-cdf", 
  "rtf": "application/rtf", 
  "mp4v": "video/mp4", 
  "dgml": "application/xml", 
  "texi": "application/x-texinfo", 
  "psc1": "application/PowerShell", 
  "pko": "application/vnd.ms-pki.pko", 
  "xml": "text/xml", 
  "xof": "x-world/x-vrml", 
  "sv4cpio": "application/x-sv4cpio", 
  "jar": "application/java-archive", 
  "slupkg-ms": "application/x-ms-license", 
  "ocx": "application/octet-stream", 
  "vbproj": "text/plain", 
  "vbdproj": "text/plain", 
  "xmp": "application/octet-stream", 
  "ief": "image/ief", 
  "onea": "application/onenote", 
  "AddIn": "text/xml", 
  "sst": "application/vnd.ms-pki.certstore", 
  "woff": "application/font-woff", 
  "cpio": "application/x-cpio", 
  "ssm": "application/streamingmedia", 
  "xdr": "text/plain", 
  "dv": "video/x-dv", 
  "woff2": "application/font-woff2", 
  "mfp": "application/x-shockwave-flash", 
  "bas": "text/plain", 
  "crt": "application/x-x509-ca-cert", 
  "settings": "application/xml", 
  "oxt": "application/vnd.openofficeorg.extension", 
  "eml": "message/rfc822", 
  "disco": "text/xml", 
  "crd": "application/x-mscardfile", 
  "mp2v": "video/mpeg", 
  "x": "application/directx", 
  "crl": "application/pkix-crl", 
  "emz": "application/octet-stream", 
  "rmp": "application/vnd.rn-rn_music_package", 
  "art": "image/x-jg", 
  "accdt": "application/msaccess", 
  "xlsb": "application/vnd.ms-excel.sheet.binary.macroEnabled.12", 
  "library-ms": "application/windows-library+xml", 
  "sea": "application/octet-stream", 
  "qtl": "application/x-quicktimeplayer", 
  "rmi": "audio/mid", 
  "qti": "image/x-quicktime", 
  "movie": "video/x-sgi-movie", 
  "spl": "application/futuresplash", 
  "dlm": "text/dlm", 
  "dll": "application/x-msdownload", 
  "qtif": "image/x-quicktime", 
  "xsl": "text/xml", 
  "xslt": "text/xml", 
  "wm": "video/x-ms-wm", 
  "js": "application/javascript", 
  "sv4crc": "application/x-sv4crc", 
  "skp": "application/x-koan", 
  "c": "text/plain", 
  "etx": "text/x-setext", 
  "xlam": "application/vnd.ms-excel.addin.macroEnabled.12", 
  "s": "text/plain", 
  "psess": "application/xml", 
  "cod": "image/cis-cod", 
  "pdf": "application/pdf", 
  "tli": "text/plain", 
  "tlh": "text/plain", 
  "etl": "application/etl", 
  "xltm": "application/vnd.ms-excel.template.macroEnabled.12", 
  "roff": "application/x-troff", 
  "cxx": "text/plain", 
  "rdlc": "application/xml", 
  "pot": "application/vnd.ms-powerpoint", 
  "cd": "text/plain", 
  "m13": "application/x-msmediaview", 
  "xltx": "application/vnd.openxmlformats-officedocument.spreadsheetml.template", 
  "m14": "application/x-msmediaview", 
  "cs": "text/plain", 
  "rpm": "audio/x-pn-realaudio-plugin", 
  "ppsx": "application/vnd.openxmlformats-officedocument.presentationml.slideshow", 
  "jnlp": "application/x-java-jnlp-file", 
  "ps": "application/postscript", 
  "java": "application/octet-stream", 
  "xap": "application/x-silverlight-app", 
  "rgb": "image/x-rgb", 
  "swf": "application/x-shockwave-flash",
  "json": "application/json", 
  "ruleset": "application/xml", 
  "xaf": "x-world/x-vrml", 
  "oth": "application/vnd.oasis.opendocument.text-web", 
  "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
  "dotx": "application/vnd.openxmlformats-officedocument.wordprocessingml.template", 
  "nc": "application/x-netcdf", 
  "otf": "application/font-sfnt", 
  "otg": "application/vnd.oasis.opendocument.graphics-template", 
  "bmp": "image/bmp", 
  "xlsm": "application/vnd.ms-excel.sheet.macroEnabled.12", 
  "m1v": "video/mpeg", 
  "otp": "application/vnd.oasis.opendocument.presentation-template", 
  "ots": "application/vnd.oasis.opendocument.spreadsheet-template", 
  "ott": "application/vnd.oasis.opendocument.text-template", 
  "dotm": "application/vnd.ms-word.template.macroEnabled.12", 
  "ppsm": "application/vnd.ms-powerpoint.slideshow.macroEnabled.12", 
  "wrz": "x-world/x-vrml", 
  "air": "application/vnd.adobe.air-application-installer-package+zip", 
  "hdf": "application/x-hdf", 
  "sln": "text/plain", 
  "slk": "application/vnd.ms-excel", 
  "p7b": "application/x-pkcs7-certificates", 
  "aif": "audio/aiff", 
  "mbox": "application/mbox", 
  "p7c": "application/pkcs7-mime", 
  "vb": "text/plain", 
  "exe.config": "text/xml", 
  "jpb": "application/octet-stream", 
  "jpe": "image/jpeg", 
  "jpg": "image/jpeg", 
  "pkgundef": "text/plain", 
  "avi": "video/x-msvideo", 
  "mqv": "video/quicktime", 
  "dtsConfig": "text/xml", 
  "wks": "application/vnd.ms-works", 
  "texinfo": "application/x-texinfo", 
  "hxc": "application/xml", 
  "wdp": "image/vnd.ms-photo", 
  "hxa": "application/xml", 
  "hxf": "application/xml", 
  "hxe": "application/xml", 
  "hxd": "application/octet-stream", 
  "hxk": "application/xml", 
  "hxi": "application/octet-stream", 
  "hxh": "application/octet-stream", 
  "webtest": "application/xml", 
  "prx": "application/octet-stream", 
  "hxs": "application/octet-stream", 
  "hxr": "application/octet-stream", 
  "hxq": "application/octet-stream", 
  "html": "text/html", 
  "hxw": "application/octet-stream", 
  "hxv": "application/xml", 
  "hxt": "text/html", 
  "hxx": "text/plain", 
  "3gp": "video/3gpp", 
  "wps": "application/vnd.ms-works", 
  "wpl": "application/vnd.ms-wpl", 
  "user": "text/plain", 
  "sgimb": "application/x-sgimb", 
  "testrunconfig": "application/xml", 
  "p10": "application/pkcs10", 
  "fsscript": "application/fsharp-script", 
  "i": "text/plain", 
  "wmls": "text/vnd.wap.wmlscript", 
  "eps": "application/postscript", 
  "thn": "application/octet-stream", 
  "contact": "text/x-ms-contact", 
  "wmlc": "application/vnd.wap.wmlc", 
  "gsm": "audio/x-gsm", 
  "pptm": "application/vnd.ms-powerpoint.presentation.macroEnabled.12", 
  "accdb": "application/msaccess", 
  "accdc": "application/msaccess.cab", 
  "resx": "application/xml", 
  "accda": "application/msaccess.addin", 
  "accde": "application/msaccess", 
  "aiff": "audio/aiff", 
  "aifc": "audio/aiff", 
  "accdr": "application/msaccess.runtime", 
  "tcl": "application/x-tcl", 
  "accdw": "application/msaccess.webapplication", 
  "bcpio": "application/x-bcpio", 
  "vsixmanifest": "text/xml", 
  "rgs": "text/plain", 
  "cur": "application/octet-stream", 
  "adp": "application/msaccess", 
  "mix": "application/octet-stream", 
  "m4r": "audio/x-m4r", 
  "m4p": "audio/m4p", 
  "m4v": "video/x-m4v", 
  "cc": "text/plain", 
  "dll.config": "text/xml", 
  "ade": "application/msaccess", 
  "m4b": "audio/m4b", 
  "m4a": "audio/m4a", 
  "bin": "application/octet-stream", 
  "psm": "application/octet-stream", 
  "amc": "application/mpeg", 
  "mov": "video/quicktime", 
  "psd": "application/octet-stream", 
  "psp": "application/octet-stream", 
  "pst": "application/vnd.ms-outlook", 
  "mod": "video/mpeg", 
  "vdp": "text/plain", 
  "ustar": "application/x-ustar", 
  "pkgdef": "text/plain", 
  "qxd": "application/octet-stream", 
  "vdx": "application/vnd.ms-visio.viewer", 
  "manifest": "application/x-ms-manifest", 
  "xsc": "application/xml", 
  "shar": "application/x-shar", 
  "xsf": "text/xml", 
  "t": "application/x-troff", 
  "xsd": "text/xml", 
  "itms": "application/x-itunes-itms", 
  "mht": "message/rfc822", 
  "xsn": "application/octet-stream", 
  "wbk": "application/msword", 
  "sitemap": "application/xml", 
  "vss": "application/vnd.visio", 
  "vst": "application/vnd.visio", 
  "vsw": "application/vnd.visio", 
  "vsx": "application/vnd.visio", 
  "webm": "video/webm", 
  "webp": "image/webp", 
  "vsd": "application/vnd.visio", 
  "vdproj": "text/plain", 
  "vsi": "application/ms-vsi", 
  "ico": "image/x-icon", 
  "cnf": "text/plain", 
  "ics": "application/octet-stream", 
  "dbproj": "text/plain", 
  "pls": "audio/scpls", 
  "m3u8": "audio/x-mpegurl", 
  "wlpginstall3": "application/x-wlpg3-detect", 
  "asax": "application/xml", 
  "step": "application/step", 
  "vcxproj": "application/xml", 
  "wsdl": "text/xml", 
  "dcr": "application/x-director", 
  "src": "application/x-wais-source", 
  "IVF": "video/x-ivf", 
  "srf": "text/plain", 
  "idl": "text/plain", 
  "ashx": "application/xml", 
  "datasource": "application/xml", 
  "acx": "application/internet-property-stream", 
  "pmr": "application/x-perfmon", 
  "ppa": "application/vnd.ms-powerpoint", 
  "sd2": "audio/x-sd2", 
  "tiff": "image/tiff", 
  "nsc": "video/x-ms-asf", 
  "sol": "text/plain", 
  "ppm": "image/x-portable-pixmap", 
  "pps": "application/vnd.ms-powerpoint", 
  "sor": "text/plain", 
  "ppt": "application/vnd.ms-powerpoint", 
  "mka": "audio/x-matroska", 
  "rct": "text/plain", 
  "ppam": "application/vnd.ms-powerpoint.addin.macroEnabled.12", 
  "setpay": "application/set-payment-initiation", 
  "opus": "audio/ogg", 
  "wax": "audio/x-ms-wax", 
  "xps": "application/vnd.ms-xpsdocument", 
  "wav": "audio/wav", 
  "ADT": "audio/vnd.dlna.adts", 
  "sdp": "application/sdp", 
  "axs": "application/olescript", 
  "pwz": "application/vnd.ms-powerpoint", 
  "setreg": "application/set-registration-initiation", 
  "atom": "application/atom+xml", 
  "hlp": "application/winhlp", 
  "webarchive": "application/x-safari-webarchive", 
  "mtx": "application/xml", 
  "iqy": "text/x-ms-iqy", 
  "vscontent": "application/xml", 
  "fdf": "application/vnd.fdf", 
  "mts": "video/vnd.dlna.mpeg-tts", 
  "sgml": "text/sgml", 
  "rc2": "text/plain", 
  "xwd": "image/x-xwindowdump", 
  "z": "application/x-compress", 
  "aa": "audio/audible", 
  "p7r": "application/x-pkcs7-certreqresp", 
  "p7s": "application/pkcs7-signature", 
  "ai": "application/postscript", 
  "pic": "image/pict", 
  "wvx": "video/x-ms-wvx", 
  "ins": "application/x-internet-signup", 
  "inl": "text/plain", 
  "pfb": "application/octet-stream", 
  "au": "audio/basic", 
  "ini": "text/plain", 
  "rvt": "application/octet-stream", 
  "inf": "application/octet-stream", 
  "p7m": "application/pkcs7-mime", 
  "inc": "text/plain", 
  "xbm": "image/x-xbitmap", 
  "3gpp": "video/3gpp", 
  "hpp": "text/plain", 
  "jcz": "application/liquidmotion", 
  "application": "application/x-ms-application", 
  "generictest": "application/xml", 
  "tif": "image/tiff", 
  "jck": "application/liquidmotion", 
  "vsct": "text/xml", 
  "xbap": "application/x-ms-xbap", 
  "rqy": "text/x-ms-rqy", 
  "fsx": "application/fsharp-script", 
  "coverage": "application/xml", 
  "dvi": "application/x-dvi", 
  "SSISDeploymentManifest": "text/xml", 
  "3gp2": "video/3gpp2", 
  "svg": "image/svg+xml", 
  "potx": "application/vnd.openxmlformats-officedocument.presentationml.template", 
  "svc": "application/xml", 
  "itpc": "application/x-itunes-itpc", 
  "eot": "application/vnd.ms-fontobject", 
  "onetoc": "application/onenote"
};

export const MESSAGES = {
  URL_COPY: "Copied share URL to clipboard",
  URL_RECIPIENT_COPY: "Copied recipient URL to clipboard"
}

export const normalizeUrl = (url) => {
  if (!url) return '';
  try {
    return new URL(url).href; // If it's already a valid URL, return it
  } catch {
    return new URL(`https://${url}`).href; // Prepend "https://" if it's not a valid URL
  }
};

export const mimeTypeExtensionByType = (type) => {
  return Object.keys(MIME_TYPES).find( key => MIME_TYPES[key] === type);
}

export const copyToClipboard = (text, notifyText) => {
  // console.log(text, notifyText);
  var textField = document.createElement('textarea')
  textField.innerText = text
  document.body.appendChild(textField)
  textField.select()
  document.execCommand('copy')

  toast.success(notifyText || MESSAGES.URL_COPY, {
    position: toast.POSITION.TOP_RIGHT
  });
  textField.remove()
}

export const numberWithCommas = (x) => {
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

/**
 * Given a url with parameters and one of them being the code (auth code), then extract
 * the auth code, as it may contain an '&' itself, breaking traditional url param parsing.
 * CODE is given as the "password" param
 * @param {String} url The URL containing the auth code delimited by CODE
 */
export const codeAndParamsFromUrl = (url) => {
  const code = url.split('CODE')[1];
  // clean up janky code handling
  // TODO fix this long term
  let codeRegex = new RegExp(`code=CODE${code}CODE`, "g");
  let normalizedUrl = url.replace(codeRegex, '');
  codeRegex = new RegExp(`password=CODE${code}CODE`, "g");
  normalizedUrl = url.replace(codeRegex, '');
  const params = querystring.parse(normalizedUrl);
  return {
    code,
    ...params
  };
}

/**
 * Given a URL with params query string, decode the params and return the JSON decoded object
 * Expects the query params are encoded and base64 JSON
 * Of the form: 
 * params = {
 *  code: "XXXXYYYY",
 *  username: "dave+appsumotest01@contentcamel.io",
 *  userId: "UUID-11-11",
 *  userPoolId: "us-west-2-xx-yy",
 *  region: "us-west-2",
 *  email: "dave+appsumotest01@contentcamel.io",
 * }
 * and the url is of the form: "?params=XXXXYYYY"
 */
export const paramsFromBase64Url = (url) => {
  
  try {
    // clean up string
    const cleanedUrl = url.replace("?params=", "params=");
    const parsedQuery = querystring.parse(cleanedUrl);
    const { params } = parsedQuery;
    let paramsJson = {};
    if (url) {
      const decodedParams = decodeURIComponent(params);
      paramsJson = JSON.parse(Buffer.from(decodedParams, 'base64').toString('utf8'));
    }
    return paramsJson;
  } catch (error) {
    console.error({functionName: "paramsFromBase64Url", error: error.toString()});
    throw new Error(error);
  }
}

export const removeParameterFromUrl = (url, parameterName) => {
  if (!url || !url.trim()) {
    return url;
  }

  return url
    .replace(new RegExp('[?&]' + parameterName + '=[^&#]*(#.*)?$'), '$1')
    .replace(new RegExp('([?&])' + parameterName + '=[^&]*&'), '$1');
};

/**
 * Given an item, return the correct image thumbnail url
 * Order of preference:
 * - item.thumbnail.url (an ssl url)
 * - item.thumbnail.ssl_url (fallback)
 * - item.meta.ogImage.url (link)
 * - item.meta.twitterImage.url (link)
 * @param {Object} item 
 * @returns 
 */
export const getThumbnailUrlForItem = (item) => {
  let imageUrl = "";
  if (!item) {
    return imageUrl;
  }
  imageUrl = _.get(item, 'thumbnail.url', '');
  if (!imageUrl) {
    imageUrl = _.get(item, 'thumbnail.ssl_url', null);
    
    if (!imageUrl) {
      imageUrl = _.get(item, 'meta.ogImage.url', null);

      if (!imageUrl) {
        imageUrl = _.get(item, 'meta.twitterImage.url', null);
      }
    }
  }

  return imageUrl;
}

export const addEventNameToEndpoint = (Analytics, eventName) => {
  const eventNames = Analytics._config.AWSPinpoint.endpoint.attributes.eventName || [];
  
  if (!eventNames.includes(eventName)) {
    Analytics.updateEndpoint({
      attributes: {
        eventName: [ ...eventNames, eventName ]
      }
    });
  }
}

